export default "__VITE_ASSET__b57248c9__"